export default {
  fromServer: data => ({
    defaultManagers: data.default_managers,
    defaultReviewers: data.default_reviewers,
    defaultReviewPeriod: data.default_review_period,
    rfiVersion: data.rfi_version,
  }),
};
